import {Link} from '@tanstack/react-router'
import {Children, useMemo} from 'react'
import parse from 'html-react-parser'
import Card from '~/components/common/Card'
import {IconPicker} from 'sanity.types'

export type Assurance = {
    _key: string
    _type: 'assurance'
    icon: IconPicker
    title?: string
    description?: string
    link?: {
        label: string
        link: string
    }
}

type AssuranceColumnProps = Assurance

const AssuranceColumn = ({icon, title, description, link}: AssuranceColumnProps) => {
    const parsedIcon = useMemo(() => {
        if (!icon.svg) {
            return undefined
        }

        return parse(icon.svg)
    }, [icon.svg])

    return (
        <Card className="p-6 md:px-8 space-y-4 text-center md:h-full">
            {!!parsedIcon && (
                <div className="[&>*]:!size-8 [&>*]:mx-auto">{Children.only(parsedIcon)}</div>
            )}
            <div className="space-y-1">
                <h3 className="text-lg font-bold">{title}</h3>
                {!!description && <p>{description}</p>}
            </div>
            {!!link && (
                <div>
                    <Link to={link.link} className="font-medium text-green-600">
                        {link.label}
                    </Link>
                </div>
            )}
        </Card>
    )
}

export default AssuranceColumn
